"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AccessData_1 = __importDefault(require("../models/AccessData"));
class AccessPanelService {
    constructor(url = '') {
        this.data = new AccessData_1.default();
        this.url = url;
        this.isLoading = false;
    }
    async call() {
        await this.fetch();
    }
    async fetch() {
        this.isLoading = true;
        try {
            const request = await fetch('/biomemakers-access');
            const response = await request.json();
            this.data = new AccessData_1.default(response);
        }
        catch (error) {
            console.log(error);
        }
        this.isLoading = false;
    }
}
exports.default = AccessPanelService;
